export enum SistemasPublicsoftEnum {
  LICITACAO = 0,
  CONTROLE_ESTOQUE = 1,
  CONTROLE_FROTA = 2,
  FARMACIA_PUBLICA = 3,
  CONTROLE_PATRIMONIO = 4,
  ACAO_SOCIAL = 5,
  CONTROLE_ESTOQUE_CONSTRUCAO_CIVIL = 6,
  EMISSOR_CHEQUES = 7,
  FOLHA_PAGTO_PUBLICA = 8,
  CONTABILIDADE = 9,
  INTERNO_PUBLICSOFT = 10,
  DIGITALIZACAO = 11,
  ARRECADACAO = 12,
  TESOURARIA = 13,
  PROTOCOLO = 14,
  ATUALIZACOESSISTEMAS = 15,
  PORTAL_TRANSPARENCIA = 16,
  CLIENTSIDE = 17,
  CLIENTSIDE_REPORT = 18,
  HUBCLOUD = 19,
  CONTROLE_INTERNO = 20,
  TODOS = 21,
  PORTAL_CONTRIBUINTE = 22,
}

export const SistemasPublicsoftColors = {
  ['DIGITALIZACAO']: '#000000',
  ['ACAO_SOCIAL']: '#865076',
  ['CONTROLE_PATRIMONIO']: '#855400',
  ['PROTOCOLO']: '#bd6f1b',
  ['FOLHA_PAGTO_PUBLICA']: '#059a92',
  ['RECURSOS_HUMANOS']: '#059a92',
  ['LICITACAO']: '#0595e0',
  ['CONTROLE_FROTA']: '#003861',
  ['CONTABILIDADE_PUBLICA']: '#015e9e',
  ['CONTABILIDADE']: '#015e9e',
  ['ARRECADACAO']: '#056e3a',
  ['TRIBUTARIO']: '#056e3a',
  ['FARMACIA_PUBLICA']: '#e70303',
  ['FARMACIA_BASICA']: '#e70303',
  ['FARMACIA']: '#e70303',
  ['CONTROLE_ESTOQUE']: '#8e052b',
};
